module.exports = __webpack_public_path__ + "img/Group.2caceb63.svg";